import {Controller} from '@stimulus/core'
import FroalaEditor from 'froala-editor'
import 'froala-editor/js/plugins/align.min.js'
import 'froala-editor/js/plugins/link.min.js'
import 'froala-editor/js/plugins/lists.min.js'
import 'froala-editor/js/plugins/quote.min.js'
import 'froala-editor/js/third_party/spell_checker.min.js'
import 'froala-editor/js/third_party/font_awesome.min.js'
import 'froala-editor/js/languages/ru.js'


// data-controller='hs--mask'

export default class extends Controller {
  connect() {
    new FroalaEditor(this.element, {
      language: 'ru'
    })
  }
}
